import React from "react";
import { hashHistory } from "react-router";
import LogoImage from "../../assets/images/2018/Logo.png";

const Menu = props => {
  const linkClick = link => {
    hashHistory.push(link);
    props.toggleMenu();
  };
  return (
    <div
      className={`menuWrapper ${props.toggled ? "toggled" : ""}`}
      onClick={() => props.isDesktop && props.toggleMenu()}
    >
      <div className="menu-logo-wrapper">
        <div className="close-menu-toggle" onClick={props.toggleMenu} />
        <img src={LogoImage} />
      </div>
      <ul className="menu">
        <li onClick={() => linkClick("/")}>Home</li>
        <li onClick={() => linkClick("/how")}>How it works</li>
        <li onClick={() => linkClick("/proceed")}>Ready to proceed</li>
        <li onClick={() => linkClick("/contact")}>Contact Us</li>
        <li onClick={() => linkClick("/mission")}>Our mission</li>
        <li onClick={() => linkClick("/faq")}>FAQ</li>
        <li onClick={() => linkClick("/legal")}>Legal</li>
      </ul>
    </div>
  );
};
export default Menu;



// WEBPACK FOOTER //
// ./components/Controls/Menu.js